const Audio = {
  CASCADING_NO_AUDIO_ID: 1,
};

export default Audio;
